import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ClipboardModule } from 'ngx-clipboard';
import { SharedModule } from '../shared.module';
import { KbTemplateModule } from '../../kb/kbtemplate.module';
import { CmsWrapperComponent } from './cmswrapper.component';
import { CmsWrapperRoutingModule } from './cmswrapper.routing.module';
import { RouterModule } from '@angular/router';
import { BreadcrumbModule } from '../../breadcrumb/breadcumb.module';

@NgModule({
  imports: [
    CommonModule,         
    NgbModule, 
    SharedModule,
    KbTemplateModule,
    CmsWrapperRoutingModule,
    BreadcrumbModule 
  ],
  declarations: [
    CmsWrapperComponent
  ],
  providers: [
  ]
})

export class CmsWrapperModule {}